import { InvitationsTrustpilotInvitationsApiModelV1ResponsesInvitationInvitationScheduledStatusResponse } from "@trustpilot/api-model";
import { metadata } from "@trustpilot/resources";

import configuration from "../configuration";
import { APPSHELL_PREFERENCES, NEW_NAVIGATION_SEEN } from "../constants";
import { BaseDataResponseBody, ShellSecondaryDataResponseBody } from "../types";
import { get, post } from "./http";

const APP_NAME = "appshellnotifications";
const NOTIFICATIONS_SEEN = "notifications-seen";
const WHATS_NEW_SEEN = "whats-new-seen";
const WHATS_NEW_ACKNOWLEDGED = "whats-new-acknowledged";
const JOB_ROLE = "job-role";

export const postComplianceUser = (simplicityData: any) =>
  post("/v1/private/compliance/business-user-logged-in", {
    data: { simplicityData },
  });

export const acceptComplianceNotification = (businessUnitId: BaseDataResponseBody["businessUnit"]["id"], data: any) =>
  post(`/v1/private/business-unit-compliance/${businessUnitId}/accept-notification`, {
    data,
  });

export const setSeenNotifications = (
  seenNotifications: ShellSecondaryDataResponseBody["notifications"],
  businessUnitId: BaseDataResponseBody["businessUnit"]["id"],
  businessUserId: BaseDataResponseBody["businessUser"]["id"],
) =>
  post(`/v1/private/business-users/${businessUserId}/businessapp-preferences?businessUnitId=${businessUnitId}`, {
    data: {
      value: JSON.stringify(seenNotifications.filter((n) => n.state === "seen").map((n) => n.id)),
      context: APP_NAME,
      name: NOTIFICATIONS_SEEN,
    },
  });

export const setSeenWhatsNew = (
  seenWhatsNew: ShellSecondaryDataResponseBody["notifications"],
  businessUserId: BaseDataResponseBody["businessUser"]["id"],
) => {
  post(`/v1/private/business-users/${businessUserId}/businessapp-preferences`, {
    data: {
      value: JSON.stringify(seenWhatsNew.filter((n) => n.state === "seen").map((n) => n.id)),
      context: APP_NAME,
      name: WHATS_NEW_SEEN,
    },
  });
};

export const setAcknowledgedWhatsNew = (ids: string[], businessUserId: BaseDataResponseBody["businessUser"]["id"]) =>
  post(`/v1/private/business-users/${businessUserId}/businessapp-preferences`, {
    data: {
      value: JSON.stringify(ids),
      context: APP_NAME,
      name: WHATS_NEW_ACKNOWLEDGED,
    },
  });

export const setJobRole = (jobRole: string, businessUserId: BaseDataResponseBody["businessUser"]["id"]) =>
  post(`/v1/private/business-users/${businessUserId}/businessapp-preferences`, {
    data: {
      value: jobRole,
      context: APP_NAME,
      name: JOB_ROLE,
    },
  });

export const setSeenNewNavigationModal = (businessUserId: BaseDataResponseBody["businessUser"]["id"]) =>
  post(`/v1/private/business-users/${businessUserId}/businessapp-preferences`, {
    data: {
      value: "true",
      context: APPSHELL_PREFERENCES,
      name: NEW_NAVIGATION_SEEN,
    },
  });

export const getInvitationsScheduledStatus = async (
  businessUnitId: string,
): Promise<InvitationsTrustpilotInvitationsApiModelV1ResponsesInvitationInvitationScheduledStatusResponse> => {
  const response = await get(
    `/v1/private/business-units/${businessUnitId}/invitations-scheduled-status`,
    null,
    configuration["TrustpilotInvitationsApi.Host"],
  );
  return response.data;
};

export const getReviewSources = (locale: string) => metadata.getAllReviewSources(locale);

export * from "./data";
